import { getEnvConfig } from '../utils/commonUtil.js';
declare global {
  interface Window {
    $sflyAuth: any;
    initSflyAuth: () => Promise<void>;
  }
}

export const getAuthInfo = async () => {
  let sessionInfo = {};
  if (!window.$sflyAuth) {
    await window.initSflyAuth();
  }
  try {
    const {
      jwtToken: access_token,
      payload: {
        data_center: account_dc,
        email: userEmail,
        family_name: lastName,
        given_name: firstName,
        sfly_uid: account_id,
        sfly_uid,
        context,
        user_type: userType,
        sg: source_group,
      },
    } = await window.$sflyAuth.getIdToken();
    sessionInfo = {
      access_token,
      account_dc,
      userEmail,
      lastName,
      firstName,
      account_id,
      sfly_uid,
      userType,
      source_group,
      context,
    };
    return sessionInfo;
  } catch (err) {
    const envConfig = getEnvConfig();
    window.location.href = `${envConfig.shopping ?? ''}/cart/shoppingcart`;
    throw new Error('Failed to fetch auth info');
  }
};
